import type { StartAccountVerificationResponse } from "@fooji/microsites";
import { writable } from "svelte/store";

export type VerifyStore = {
  verificationData: StartAccountVerificationResponse | null;
  onVerifyCallback: () => void;
};

export const verifyStore = writable<VerifyStore>({
  verificationData: null,
  onVerifyCallback: () => {}
});
